import SearchApi from '../../api/SearchApi';

import { useState, useContext, Fragment } from 'react';
import UserContext from '../../context/UserContext';
import { loginAlert } from '../common/CustomAlert';

const inputHandlerBuilder = setState => {
    return e => setState(e.target.value);
}

// const defaultRankList = ['-', '-', '-', {}, '-'];
const defaultTmpSlot = ['-', '-', '-', '-', '-', '-', '-', '-'];

const Search = props => {
    const { user } = useContext(UserContext);
    const { api, useKeyword = true, targetPlaceholder = '상품명', waitingTime = 12000 } = props;
    const [keyword, setKeyword] = useState('');
    const [prodNm, setProdNm] = useState('')
    const [isLoading, setIsLoading] = useState(false);
    // const [rankList, setRankList] = useState(defaultRankList);
    const [tmpSlot, setTmpSlot] = useState(defaultTmpSlot);
    const { headers = ['순위', '상품명'], dataIdx = [2, 5], dataManupulator = d => d, customTable } = props;

    const handleSearchClick = async e => {
        e.preventDefault();
        if (!user || !user.userId) return loginAlert('로그인을 하셔야 합니다.');
        if ((useKeyword && !keyword) || !prodNm) return alert('검색어를 입력하셔야 합니다.');
        setTmpSlot(defaultTmpSlot)
        const res = await api(keyword, prodNm);
        if (res.tmpSlotId) handleSearchComplete(res.tmpSlotId)
    }

    const handleSearchComplete = tmpSlotId => {
        let totalWatingTime = 0;
        const fetchSlot = timer => {		
			setTimeout(() => {
				SearchApi.getTmpSlot(tmpSlotId, true).then(rslt => {
                    totalWatingTime += timer;
					if(rslt.tmpSlot) {
						setTmpSlot(rslt.tmpSlot);
                        setIsLoading(false);
						return;
					}
					if (totalWatingTime < 30000) {
						fetchSlot(waitingTime / 2);
					} else {
                        setIsLoading(false);
                        alert('검색이 실패했습니다. 입력값을 확인 후 다시 시도해 주세요.');
                        setTmpSlot(defaultTmpSlot);
                    } 
				});
			}, timer);
		}
        setIsLoading(true);
		fetchSlot(waitingTime);
    }

    return (
        <div className='vh-content'>
            <div className="search-container">
                <div className="search-section mobile-flex-colnum">
                    {useKeyword && <div className="input-icon">
                        <input type="text" placeholder="검색어" className="search-keyword" 
                            value={keyword} onChange={inputHandlerBuilder(setKeyword)} 
                        />
                    </div>}
                    <input type="text" placeholder={targetPlaceholder} className="search-url"
                            value={prodNm} onChange={inputHandlerBuilder(setProdNm)}
                        />
                    <button className="search-btn" onClick={handleSearchClick} disabled={isLoading}>검색</button>
                </div>
                <div className="search-results">
                    <div className="rank-results-table">
                        {customTable 
                            ? <>{customTable({tmpSlot, isLoading})}</>
                            :<table>
                                <colgroup>
                                    {headers.map(h => <col width="50%" />)}
                                </colgroup>
                                <thead>
                                    <tr>
                                        {headers.map(h => <th>{h}</th>)}
                                    </tr>    
                                </thead>
                                <tbody>
                                    {isLoading 
                                        ? <tr>
                                            <td colspan={headers.length} className="rank-loading-overlay">
                                                <div className="loading-spinner" style={{ margin: 'auto' }}></div>
                                                <div className="loading-message">
                                                    <span>순위 조회 중입니다. 잠시만 기다려 주세요.</span>
                                                </div>
                                            </td>
                                        </tr>
                                        : <tr>
                                            {dataIdx.map(idx => <td>
                                                {dataManupulator(tmpSlot[idx])}
                                            </td>)}                                        
                                        </tr>
                                    }
                                </tbody>    
                            </table>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Search;